import { render, staticRenderFns } from "./DoYouWantImmediateCash.vue?vue&type=template&id=0b5576a4&scoped=true"
import script from "./DoYouWantImmediateCash.vue?vue&type=script&lang=js"
export * from "./DoYouWantImmediateCash.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b5576a4",
  null
  
)

export default component.exports